<template>
  <DoubleColumn>
    <template #header>
      <section class="sm:flex sm:items-center sm:justify-between">
        <div class="sm:flex sm:space-x-5">
          <h1 class="text-3xl font-bold text-white">
            Fehlt nur noch dein persönlicher Account
          </h1>
        </div>
      </section>
    </template>
    <template #left>
      <section>
        <div class="bg-white shadow overflow-hidden sm:rounded-lg">
          <div class="px-4 py-5 sm:px-6">
            <h2>Dein St. Audio Profil</h2>
            <FormGroup v-if="resource">
              <FormField class="sm:col-span-6" field="username" :errors="errors">
                <template #label>
                  Vorname Name
                </template>
                <template #input="props">
                  <InputText v-model="resource.username" id="username" :class="props['class']"/>
                </template>
              </FormField>
              <FormField class="sm:col-span-6" field="position" :errors="errors">
                <template #label>
                    Position
                </template>
                <template #input="props">
                  <InputSelect v-model="resource.position" id="position" :options="position" :class="props['class']"/>
                </template>
              </FormField>
              <FormField class="sm:col-span-6" field="language" :errors="errors">
                <template #label>
                    Sprache
                </template>
                <template #input="props">
                  <InputSelect v-model="resource.language" id="language" :options="language" :class="props['class']"/>
                </template>
              </FormField>
              <FormField class="sm:col-span-6" field="referrer" :errors="errors">
                <template #label>
                    Wie bist du auf St. Audio aufmerksam geworden?
                </template>
                <template #input="props">
                  <InputSelect v-model="resource.referrer" id="referrer" :options="referrer" :class="props['class']"/>
                </template>
              </FormField>
            </FormGroup>
          </div>
          <div class="px-6 pb-6 divide-y divide-gray-200">
            <div class="flex justify-end">
              <SubmitButton @click="onSubmit" :load="creating">
                Los geht's
              </SubmitButton>
            </div>
          </div>
        </div>
      </section>
    </template>
    <template #right>
      <section>
        <div class="bg-white shadow overflow-hidden sm:rounded-lg">
          <div class="px-4 py-5 sm:px-6">
            <StepWizard :step="2" />
          </div>
        </div>
      </section>
    </template>
  </DoubleColumn>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useOnboardingRouter } from '@/router/routers';
import { useCreateResource } from '@/client/actions';
import { language } from '@/static/enums';
import { position } from '@/static/enums';
import { referrer } from '@/static/enums';

const props = defineProps({id: String});
const router = useOnboardingRouter();
const store = useStore();

const parent = computed(() => props.id);

const target = computed(() => '/api/account/profile');
const action = useCreateResource(target);

const { resource, errors, message, create, creating } = action;

const reload = () => store.dispatch('auth/reload')
const promise = () => new Promise((r, _) => r(reload()));
const redirect = () => router.complete(parent.value);


onMounted(() => {
// skip this step if the user already has a profile
if(store.getters['auth/user'].profile !== null) {
    redirect();
  }
});

const onSuccess = () => promise().then(redirect);
const onSubmit = () => create(onSuccess);
</script>
